<template>
  <div >
    <div class="doc-title">
      <div class = "margin-left-l pointer flex flex-center-cz flex-space-between"  style="width: calc(100% - 700px); " >
          <div class="flex flex-center-cz ">
            <img class="logo-30" src="@/assets/images/fanhui.png" @click="home"/>
            <div class="margin-left-m font-bold row1 text-more" style="max-width: 300px;">{{docData.name}}</div>
            <img v-if="false" class="h22 margin-left-l"  src="@/assets/images/edit.png" @click="renameClick"/>
            <div class="margin-left-xxl font-m color-gold margin-right-xl">{{docData.userName}}</div>
            <div class="margin-left-s font-m color-rgb-05 ">于<span>{{docData.createTime}}</span>创建</div>
          </div>
          <div class="flex flex-center-cz" v-if="docData.docType=='test'">
            <SearchInput  :placeholder="'请输入责任人查询，更多条件点更多'" style="width: 300px;margin-top: 5px" @search="testSearch"></SearchInput>
            <div class="margin-left-m font-s pointer" @click="moreFilterClick">更多</div>
          </div>
          <!-- <div v-if="docData.files!=null && docData.files.length>1" class="color-rgb-05 " >共<span class="color-blue ">{{docData.files.length}}</span>个版本</div>
          <div class="flex flex-center-cz" style="width: calc(100% - 380px); height: 35px; " v-if="docData.files!=null && docData.files.length>1">
            <vue-custom-scrollbar class="full-width" >
              <div  class="flex " id="verid">
                    <div  v-for="item in docData.files" 
                      class="ver-item  margin-left-l"  
                      @click="verItemClick(item)"
                      :class="{'ver-item-active':activeId == item.id}" >{{item.userName}}<span v-if="userId == item.userId">(我)</span>
                    </div>
              </div>
            </vue-custom-scrollbar>
          </div> -->
      </div>
      <div class="flex flex-end flex-center-cz " style="width: 700px;">
        <div class="flex margin-right-xl flex-center-cz" v-if="docData && docData.files && docData.files.length>1">
          <div class="color-gray">共<span>{{docData.files.length}}</span>个版本：</div>
          <div class="flex flex-center-cz pointer" @click="selectVerClick">
            <div class="margin-right-m" >{{docData.fileUserName }}</div>
            <img src="@/assets/images/yizhankai.png" style="width: 14px;height: 10px;" />
          </div>

        </div>

        <div class="split-line h35"></div>
        <div class="margin-right-l font-m tag-hui flex flex-center-sp flex-center-cz pointer cannotselect" @click="version" v-if="false">历史版本</div>
        <div class="margin-right-m btn-blue-full flex flex-center-cz flex-center-sp pointer cannotselect" @click="share1()" >分享文档</div>
        <div v-show="getCanClone"  class="margin-right-m btn-blue-line flex flex-center-cz flex-center-sp pointer cannotselect" @click="clone()" >克隆文档</div>
        <div v-show="getCanEdit" class="margin-right-m btn-blue-line flex flex-center-cz flex-center-sp pointer cannotselect w80" @click="edit()" >编辑</div>
      
        
        <div class="margin-right-m btn-blue-line flex flex-center-cz flex-center-sp pointer cannotselect w80" @click="compare"
              v-if="false" >对比</div>
        <div v-if="false" class="margin-right-m btn-blue-line flex flex-center-cz flex-center-sp pointer cannotselect w80" @click="down" >下载</div>
        <div v-print="'#docPrint'" class="margin-right-m btn-blue-line flex flex-center-cz flex-center-sp pointer cannotselect w80" @click="print">打印</div>
        <img v-if="(bizType == 1 && docData.userId == userId) || (docData.docType == 'test') " class="logo-25 pointer" src="@/assets/images/icmore.png" @click="moreClick"/>

        <div class="split-line h35"></div>
        <div class="margin-right-xl margin-top-s pointer" @click="noteClick"><img class="note-ico" src="@/assets/images/note.png"/></div>
        <div class="margin-right-xl margin-top-s pointer position-relative" @click="msgInfoClick" >
          <img class="logo-25" src="@/assets/images/xiaoxi.png"/>
          <div v-if="msgCount>0" class="xiaoxi-count">{{msgCount}}</div>
        </div>
        <div class="margin-right-xl margin-top-s pointer" @click="userInfoClick" >
          <img v-if="token != null && token != '' && token != 'null'" class="logo-32" src="@/assets/images/user.png"/>
           <img v-if="token == null || token == '' || token == 'null' " class="logo-32" src="@/assets/images/wzuser.png"/>
        </div>
        <!--<div class="margin-right-l font-m ">{{userName}}</div>-->
      </div>
      
    </div>
    <div class="doc-body border-box " >

        <div class="doc-view border">
          <vue-custom-scrollbar class="full-width full-height" :settings="settings">
          <div class="rtfDiv book" >
              <div id="docPrint" v-html="docContent"  ref="docContent"></div>              
          </div>
          </vue-custom-scrollbar>
        </div>

        
        <div  class="bottom flex flex-row flex-center-sp flex-center-cz" >
          <!-- <div class="margin-right-xl pointer" v-if="fileReplyList && fileReplyList.length>0" @click="replys" >
            <span>共</span><span class="color-red">{{fileReplyList.length}}</span><span>人回复</span> 
          </div>   -->
          <div class="flex flex flex-center-sp">
              <div class="tool-bar flex flex-center-sp">
                <div class="flex flex-center-sp flex-center-cz" >
                    <div class="margin-left-xl margin-right-xl flex flex-row pointer" @click="like"><img class="logo-20" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{docData.likeCount}}</div></div>
                    <div class="margin-left-xl margin-right-xl flex flex-row" ><img class="logo-20" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{docData.viewCount}}</div></div>
                    <div class="margin-left-xl margin-right-xl flex flex-row" ><img class="logo-20" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{docData.commentCount}}</div></div>
                    <div class="margin-left-xl margin-right-xl flex flex-row pointer" @click="collect" ><img class="logo-20" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{docData.collectCount}}</div></div>                    
                </div>               
              </div>
              <div v-if="docData.docType=='test' " class="tool-bar flex flex-center-sp margin-left-l">
                <div class="flex flex-center-sp flex-center-cz" >
                    <div class="margin-left-xl margin-right-xl flex flex-row pointer flex-center-cz"><span> 总计：</span><span class="margin-left-m font-bold" v-if="totalDataInfo">{{totalDataInfo.testItemCount}}</span></div>
                    <div class="margin-left-xl margin-right-xl flex flex-row pointer flex-center-cz"><span> 完成：</span><span class="margin-left-m font-bold" v-if="totalDataInfo">{{totalDataInfo.testItemFinishCount}}</span></div>
                    <div class="margin-left-xl margin-right-xl flex flex-row pointer flex-center-cz"><span> 未完成：</span><span class="margin-left-m font-bold" v-if="totalDataInfo">{{totalDataInfo.testItemNoFinishCount}}</span></div>                 
                </div>               
              </div>

          </div>

        </div>
        <div class="right flex flex-col">
            <Comment :docId="docData.id" :data="commentData" @change="commentChange" ></Comment>
        </div>

        <div v-if="showMore" class="more padding-l flex flex-col ">
            <div class="flex flex-center-cz flex-wrap flex-top row ">

                <div class="edit-area flex flex-center-cz">
                    <div class="font-s label">状态</div>
                    <div class="value"><MySelect v-model="filter.status" :data="statusData" :value="''" :result="''"></MySelect> </div>
                </div>
                <div class="edit-area flex flex-center-cz">
                    <div class="font-s label">优先级</div>
                    <div class="value"><MySelect v-model="filter.level" :data="levelData" :value="'中'" :result="''"></MySelect> </div>
                </div>
                <div class="edit-area flex flex-center-cz">
                    <div class="font-s label">版本号</div>
                    <input type="text"  v-model="filter.verNo" class="ui-input value"/>
                </div>
                <div class="edit-area flex flex-center-cz">
                    <div class="font-s label">标签</div>
                    <input type="text"  v-model="filter.tag" class="ui-input value"/>
                </div>

                <div class="btn-blue-full flex flex-center-cz flex-center-sp cannotselect margin-left-s" @click="queryClick">查询</div>
                <div class="btn-blue-line flex flex-center-cz flex-center-sp cannotselect margin-left-m" @click="closeMoreClick">收起</div>
                <div class="btn-blue-line flex flex-center-cz flex-center-sp cannotselect margin-left-m" @click="clearClick">重置</div>
            </div>
        </div>

    </div>

    <FileVer :data="docData.files" :show="showVersion" @close="showVersion = false" @change="verChange"></FileVer>
    <Share :data="shareData" :show="showShare" @close="showShare = false"></Share>
    <Move :dirData="dirData" :show="showMove" @close="showMove = false" @change="dirChange"></Move>
    <user-info :show="showUser" @close="showUser = false"></user-info>
    <msg-info :show="showMsg" @close="showMsg = false" @change="msgChange"></msg-info>
    <popup-menu ref="opMenu" :menuData="opMenuData"  @menuClick="opMenuClick"></popup-menu>
    <UpFile :show="showUpFile" @close="showUpFile = false" @change="addFile"></UpFile>
    <DocEditModal :files="docData.files" :open="showDocEditModal" @close="saveDocClose" :mdata="docEditData" :title="'编辑'" @confirm="editDocConfirm" >
    </DocEditModal>
    <DocEditPlusModal :title="'编辑'" ref="docEditPlusModal" @close="docEditPlusClose" ></DocEditPlusModal>  
    <DocCompareModal :open="showDocCompareModal" @close="compareDocClose" :leftId="activeId" :files="docData.files"></DocCompareModal>
    <CopyConfirmModal :open="showCopyModal" @close="showCopyModal = false" @confirm="copyConfrim"></CopyConfirmModal>
    <ScanLogin  :show="showScanLogin" @close="showScanLogin = false" @confirm="loginConfirm"></ScanLogin>
    <Note :show="showNote" @close="showNote = false" ></Note>
    <DocShowModal  :open="showDocShowModal" @close="showDocShowModal=false" :mdata="docData" :title="showTitle"  ></DocShowModal>
    <DocReplyModal  :open="showDocReplyModal" @close="showDocReplyModal=false" :mdata="replyData" :title="replyTitle" @confirm="replyConfrim" ></DocReplyModal>
    <FileReplyListModal  :open="showFileReplyListModal" @close="showFileReplyListModal=false" :logs="fileReplyList"  ></FileReplyListModal>
    <SendUpdateModal :mData="sendUpdateData" :open="showSendUpdateModal" @close="showSendUpdateModal = false" @confirm="sendUpdateConfirm" ></SendUpdateModal>
    <HtmlReplyModal ref="htmlReplyModal" @confirm="afterAddHtmlReply" ></HtmlReplyModal>
    <InsertTestModal  ref="insertTestModal"  @update="updateTestConfirm" @add="insertTestConfirm"></InsertTestModal>
    <popup-menu ref="opMenuVer" :menuData="verData"  @menuClick="verClick"></popup-menu>
    <input hidden accept="*.xlsx" type="file" ref="testFileAdd" @change="getTestFile" />
    <InsertQuestionModal  ref="insertQuestionModal"  @add="insertQuestionConfirm" @update="updateQuestionConfirm"></InsertQuestionModal>
    <AnswerQuestionModal  ref="answerQuestionModal" @confirm="answerQuestionConfirm" ></AnswerQuestionModal>
  </div>


</template>


<script>
import Comment from '@/modules/comment/Comment.vue'
import Share from '@/modules/share/Share.vue'
import Move from '@/modules/move/Move.vue'
import FileVer from '@/modules/fileVer/FileVer.vue'
import UpFile from '@/modules/upFile/UpFile.vue'
import PopupMenu from '@/components/popupMenu/PopupMenu' 
import UserInfo from '@/modules/userInfo/UserInfo.vue'
import MsgInfo from '@/modules/msgInfo/MsgInfo.vue'
import {getJsDateTime} from '@/utils/dateUtils.js'
import {strToInt, debounce, getShareToken, objToStr,keepContent, isEmpty} from '@/utils/sysUtils.js'
import {generateTree} from '@/utils/sysData.js'
import {getDoc,getUserDir,uploadFileA,updateFile,changeDir,likeDoc,collectDoc,delDoc,updateDoc,getDocQueryInfo,getTestHtml,
        getPdfFile,getByEditFile,updateUserFile, getFileByShareId,getFileList,noReadMsgCount,getDocTotalInfo,
        getFile, getMyFile,getCopyFile, getReplyFile, getReplyList, saveAllHtml , testItemFinish, importTest,
        answerQuestion, postQuestion, cloneQuestion} from '@/api/api.js';
import config from '@/config/index.js'
import DocEditModal from '@/views/modal/DocEditModal'
import ScanLogin from '@/modules/scanLogin/ScanLogin.vue'
import MixinDoc from '@/mixin/mixinDoc';
import MixinHtml from '@/mixin/mixinHtml.js';
import DocCompareModal from '@/views/modal/DocCompareModal'
import CopyConfirmModal from '@/views/modal/CopyConfirmModal'
import Note from '@/modules/note/Note.vue'
import DocShowModal from '@/views/modal/DocShowModal'
import DocReplyModal from '@/views/modal/DocReplyModal'
import FileReplyListModal from '@/views/modal/FileReplyListModal'
import SendUpdateModal from '@/views/modal/SendUpdateModal'
import {sendMsgs} from '@/api/api.js';
import { allData, filterData, findByClass } from '../utils/htmlUtils'
import HtmlReplyModal from './modal/HtmlReplyModal.vue'
import InsertTestModal from '@/views/plugs/InsertTestModal'
import SearchInput from '@/components/searchInput/SearchInput.vue'
import MySelect from '@/components/select/Select' 
import { getUUID } from '@/utils/sysUtils'
import { getNowDate } from '@/utils/dateUtils'
import InsertQuestionModal from './plugs/InsertQuestionModal.vue'
import DocEditPlusModal from './modal/DocEditPlusModal.vue'
import AnswerQuestionModal from './plugs/AnswerQuestionModal.vue'


export default {
  name: 'DocDetail',
  components: {
      Share,PopupMenu,UserInfo,MsgInfo,Comment,FileVer,UpFile,Move,DocEditModal,ScanLogin,
      DocCompareModal,CopyConfirmModal,Note,DocShowModal,DocReplyModal,FileReplyListModal,
      SendUpdateModal,HtmlReplyModal,InsertTestModal,SearchInput,MySelect,InsertQuestionModal,
      DocEditPlusModal,AnswerQuestionModal
  },
  mixins:[MixinDoc,MixinHtml],
  created() {

    if (objToStr(this.$route.query.shareId) != "") {
      this.bizType = 2;
    };
  },
  computed: {
    getCanEdit() {
      return (this.docData.docType && this.docData.docType == 'default') || (this.docData.userId == this.userId)
    },
    getCanClone() {
      return this.docData.docType && this.docData.docType == 'question';
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log("to===",from)
      console.log("from===",from)
      vm.fromUrl = from.path;
    });
  },
  mounted() {
    this.getLoginInfo();
    this.initData();
    this.getMsg();

  },
  data() {
    return {
      userId: sessionStorage.getItem("userId"),
      fromUrl: "",
      documentObj:null,
      docContent:"",
      bizType: 1,
      shareId: null,
      commentData: null,
      dirData:null,
      showUpFile: false,
      showMove: false,
      showVersion: false,
      showUser: false,
      showMsg: false,
      showNote: false,
      showMore: false,
      showTitle: "",
      docData: {},
      replyTitle:"",
      replyData:null,
      sendUpdateData:{},
      docEditData:{},
      showShare: false,
      shareData:{},
      showDocEditModal:false,
      showDocShowModal: false,
      showDocCompareModal: false,
      showDocReplyModal: false,
      showSendUpdateModal:false,
      showCopyModal: false,
      showFileReplyListModal: false,
      showInsertTestModal: false,
      showInsertQuestionModal: false,
      showScanLogin: false,
      activeId: null,
      saving: false,
      msgCount: 0,
      token:  null,
      userId: null,
      userName: null ,
      fileReplyList:[],
      totalDataInfo:{
        testItemCount:0,
        testItemFinishCount:0,
        testItemNoFinishCount:0
      },
      settings: {
         suppressScrollY: false,
         suppressScrollX: true,
         wheelPropagation: false
      },
      opMenuData: [
        {id:'delete',name:'删除'},
        {id:'show',name:'显示'},
        {id:'compare',name:'对比'},
        {id:'move',name:'移动'},
        {id:'insertTest',name:'插入测试问题'},
        {id:'importTest',name:'导入测试问题'},
        {id:'insertQuestion',name:'插入试题'},
       ],
       verData:[],
       levelData:[
          {
              text:"高",
              value:'高',
          },
          {
              text:"中",
              value:'中',
          },
          {
              text:"低",
              value:"低",
          },
 
      ],
      statusData:[
          {
              text:"已完成",
              value:'已完成',
          },
          {
              text:"未完成",
              value:'未完成',
          },


      ],
      filter:{}
    }
  },


  methods:  {
    clone() {
      this.$showMsgBox({
          caption:"询问",
          msg: '确定要克隆该文档吗？',
          callback:(data) => {
              if (data == "yes") {
                cloneQuestion(this.activeId).then((res) => {
                  console.log("res=====", res);
                  this.$router.push({
                      path: '/doc',
                      query: { id: res.data.result.id }
                  })
                  window.location.reload();

                }) 
              } 
          }
      })
    },
    getTestFile() {
        let files = this.$refs.testFileAdd.files[0];
        console.log("files", files)
        this.$showLoading();
        importTest(files,this.activeId).then((res) => {
            this.queryClick();
            this.bindEvent();
            this.$closeLoading();
        })  

    },
    testSearch(value) {
      this.filter.dutyPerson = value;
      this.queryClick();

    },
    queryClick() {
        this.filter.filterType = this.docData.docType;
        this.filter.fileId = this.activeId;
        console.log(" this.filter===",  this.filter);
        this.$showLoading();
        getDocQueryInfo(this.filter).then((res) => {
          this.$closeLoading();
          console.log("query======", res.data);
          this.docContent = res.data.message;
          this.totalData();
          this.bindEvent()
          this.$forceUpdate();
        })  
    },
    clearClick() {
      this.filter = {};
    },
    closeMoreClick() {
      this.showMore = false;
    },
    moreFilterClick() {
      this.showMore = !this.showMore;

    },
    selectVerClick(event) {
      this.verData = []; 
      this.docData.files.forEach(item => {
        this.verData.push({id: item.id, name: item.userName})
      });
      this.$refs.opMenuVer.show(event);//
    },
    docEditPlusClose() {
      this.queryClick();
    },
    bindEvent() {
      let that = this;
      console.log("bindEvent====")
      this.$nextTick(() => {
          let doc = that.$refs.docContent;
          doc.querySelectorAll('.test-item-finish').forEach(function(element) {
            let finishEvent = function(event) {
                  let userId = sessionStorage.getItem("userId");
                  if (userId == null || userId == "" || userId == "null") {
                    if (config.configData.loginType == "wx") {
                      that.showScanLogin = true;
                    } else {
                      that.$router.push({
                          path: '/login',
                      }) 
                    }   
                    return false;                 
                  } 
                  let postBody = {dataId: element.dataset.id};
                  that.$showLoading();
                  testItemFinish(postBody).then((res) => {
                    that.$closeLoading();
                    that.queryClick();
                  })  
            } 
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', finishEvent); 
            }
          });

          doc.querySelectorAll('.test-item-reply').forEach(function(element) {
               let replyEvent = function(event) {
                  console.log("reply")
                  let userId = sessionStorage.getItem("userId");
                  if (userId == null || userId == "" || userId == "null") {
                    if (config.configData.loginType == "wx") {
                      that.showScanLogin = true;
                    } else {
                      that.$router.push({
                          path: '/login',
                      }) 
                    }   
                    return false;                 
                  } 
                  that.$refs.htmlReplyModal.showForm({dataId: element.dataset.id, content:""});
                }
                if (element.hasAttribute('onclick')) {
                  console.log('元素有onclick事件');
                } else {
                  console.log('元素没有onclick事件');
                  element.addEventListener('click', replyEvent );  
                }
                  
          })

          doc.querySelectorAll('.test-item-edit').forEach(function(element) {
            let editEvent = function(event) {
              console.log("edit")
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                if (config.configData.loginType == "wx") {
                  that.showScanLogin = true;
                } else {
                  that.$router.push({
                      path: '/login',
                  }) 
                }   
                return false;                 
              } 
              that.$refs.insertTestModal.showForm({dataId: element.dataset.id});
            }
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', editEvent );    
            }
            
          })

          doc.querySelectorAll('.question-item-edit').forEach(function(element) {
            let editEvent = function(event) {
              console.log("edit")
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                if (config.configData.loginType == "wx") {
                  that.showScanLogin = true;
                } else {
                  that.$router.push({
                      path: '/login',
                  }) 
                }   
                return false;                 
              } 
              that.$refs.insertQuestionModal.showForm({dataId: element.dataset.id});
            }
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', editEvent );    
              
            }
            
          })


          doc.querySelectorAll('.question-post').forEach(function(element) {
            let postEvent = function(event) {
              console.log("edit")
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                if (config.configData.loginType == "wx") {
                  that.showScanLogin = true;
                } else {
                  that.$router.push({
                      path: '/login',
                  }) 
                }   
                return false;                 
              } 
              console.log("post====")
              that.$showInputBox({
                caption:"输入姓名",
                inputValue: "",
                callback:(data) => {
                  let postBody = {fileId: that.activeId, userName: data};
                  that.$showLoading();
                  postQuestion(postBody).then((res) => {
                    console.log("res=====", res);
                    that.$closeLoading();
                    that.$closeInputBox();
                    that.docContent = res.data.result.content;
                    that.bindEvent()
                    that.$forceUpdate();
                    that.$showToast({msg: "考试成绩：" +res.data.result.score + "分" });
                  }) 
                }
              })          
            }
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', postEvent );    
              
            }
            
          })


          doc.querySelectorAll('.question-item-input').forEach(function(element) {

            let inputEvent = function(event) {
              console.log("edit")
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                if (config.configData.loginType == "wx") {
                  that.showScanLogin = true;
                } else {
                  that.$router.push({
                      path: '/login',
                  }) 
                }   
                return false;                 
              } 
              that.$refs.answerQuestionModal.showForm({dataId: element.dataset.id, dataResult: element.dataset.result});
            }
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', inputEvent );    
              
            }
            
          })



          doc.querySelectorAll('.question-item-info').forEach(function(element) {
            let answerEvent = function(event) {
                  let userId = sessionStorage.getItem("userId");
                  if (userId == null || userId == "" || userId == "null") {
                    if (config.configData.loginType == "wx") {
                      that.showScanLogin = true;
                    } else {
                      that.$router.push({
                          path: '/login',
                      }) 
                    }   
                    return false;                 
                  } 
                  console.log("选中了：" )
                  let postBody = {dataId: element.dataset.id, fileId: that.activeId, result: element.dataset.result};
                  that.$showLoading();
                  answerQuestion(postBody).then((res) => {
                    console.log("res=====", res);
                    that.$closeLoading();
                    that.docContent = res.data.message;
                    that.bindEvent()
                    that.$forceUpdate();
                  })  
            } 
            if (element.hasAttribute('onclick')) {  
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件111');
              if (sessionStorage.getItem("userId") != that.docData.userId) {
                element.addEventListener('click', answerEvent); 
              }

            }
          })

          doc.querySelectorAll('.question-item-error-count').forEach(function(element) {
            let errorEvent = function(event) {
              console.log("question-item-error-count")
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                if (config.configData.loginType == "wx") {
                  that.showScanLogin = true;
                } else {
                  that.$router.push({
                      path: '/login',
                  }) 
                }   
                return false;                 
              } 
              console.log("error count====")
              that.$showToast({msg: "答错人员：" + element.dataset.users});

            }
            if (element.hasAttribute('onclick')) {
              console.log('元素有onclick事件');
            } else {
              console.log('元素没有onclick事件');
              element.addEventListener('click', errorEvent );    
              
            }            
          })
      })
    },
    afterAddHtmlReply() {
      console.log("afterAddHtmlReply")
      this.queryClick();
    },
    answerQuestionConfirm(content) {
      console.log("content====", content);
      let postBody = {dataId: content.dataId, fileId: this.activeId, resultType:content.dataResult, result: content.result};
      console.log("postBody===", postBody)
      this.$showLoading();
      answerQuestion(postBody).then((res) => {
        console.log("res=====", res);
        this.$closeLoading();
        this.docContent = res.data.message;
        this.bindEvent()
        this.$forceUpdate();
        this.$refs.answerQuestionModal.close();
      })  

      

    },
    updateQuestionConfirm(content) {
      let postData = [];
        let fileId = this.activeId;
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-index", "value":content.index});
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-title", "value": content.title}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-a", "value":content.optionA}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-b", "value":content.optionB}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-c", "value":content.optionC}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-d", "value":content.optionD}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-result", "value":content.result}); 

        this.$showLoading();
        saveAllHtml(postData).then( async (res) => {
            this.$closeLoading();
            if (res.data.success == true) {
                this.$showToast({msg: '操作成功！'}) 
                this.queryClick();
                this.$refs.insertQuestionModal.close();
            } else {
               this.$showToast({msg: res.data.message})
            }
        }) 

    },
    updateTestConfirm(content) {
        let postData = [];
        let fileId = this.activeId;
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-finish", "value": content.finish});
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-status", "value": content.status}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-date", "value":content.date}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-level", "value":content.level}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-duty-person", "value":content.dutyPerson}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-tag", "value":content.tag}); 
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-verno", "value":content.verNo});
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-content", "value":content.content});
        postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-creater", "value":content.creater});

        this.$showLoading();
        saveAllHtml(postData).then( async (res) => {
            this.$closeLoading();
            if (res.data.success == true) {
                this.$showToast({msg: '操作成功！'}) 
                this.queryClick();
                this.$refs.insertTestModal.close();
            } else {
               this.$showToast({msg: res.data.message})
            }
        }) 

    },
    // insertTestConfirm(content) {
    //     console.log("test", content)
    //     let newId = getUUID()
    //     let nowDate = getNowDate();
    //     let creater = sessionStorage.getItem("realname");
    //     content.date = nowDate;
    //     content.creater = creater;
    //     content.id = newId;
    //     this.$showLoading();
    //     getTestHtml(content).then((res) => {
    //         this.$closeLoading();
    //         if (res.data.success == true) {                     
    //             let docContent = objToStr(this.docContent) + res.data.message;   
    //             let postData = [];
    //             let fileId = this.activeId;
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-finish", "value":"完成"});
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-status", "value":"未完成"}); 
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-date", "value":nowDate}); 
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-level", "value":content.level}); 
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-duty-person", "value":content.dutyPerson}); 
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-tag", "value":content.tag}); 
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-verno", "value":content.verNo});
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-content", "value":content.content});
    //             postData.push({"fileId": fileId, "dataId": newId, "className": "test-item-creater", "value":creater});
                
    //             this.$showLoading();
    //             saveAllHtml(postData).then((res) => {
    //                 this.$closeLoading();
    //                 if (res.data.success == true) {                     
    //                     let data = {id: this.activeId, content: docContent, name: this.docData.name, sendMsg: 0};
    //                     this.$showLoading(); 
    //                     updateUserFile(data).then((res1) => {
    //                         this.$closeLoading();
    //                         if (res1.data.success == true) {
    //                           this.$showToast({msg: '操作成功！'}) 
    //                           this.showInsertTestModal = false;
    //                           this.queryClick();
    //                         } else {
    //                           this.$showToast({msg: res1.data.message})
    //                         }
    //                     }) 

    //                 }
    //             }) 
    //         } else {
    //             this.$showToast({msg: res.data.messeage})
    //         }
    //     }) 
    // },
    sendUpdateConfirm(data) {
          let postBody = [];
          console.log("files=====", this.files);
          console.log("data=====", data);
          let content = data.content;
          let allUser = data.allUser;
          let selectVer = data.selectVer;

          this.docData.files.forEach(item => {
              
              if (content.length > 0) {
                  if (allUser == false) {
                      if (item.userId == selectVer) {
                          postBody.push({
                              "content": content, 
                              "msgType": 4,
                              "toUserId": item.userId,
                              "toUserName": item.userName,
                              "fileId": item.id
                          }) 
                      }
                  }  
              }                 
          });
          console.log("postBody=====", postBody);
          sendMsgs(postBody).then((res) => {
              if (res.data.success == true) {
                  this.$showToast({
                      msg: '操作成功！' 
                  }) 
                  this.showSendUpdateModal = false;
              }
          })                           
      },
      home() {

          let backUrl = this.fromUrl; //this.$route.query.backUrl;
          if (objToStr(backUrl) != "") {
            this.$router.push({
                path: backUrl,
            })            
          } else {
            this.$router.push({
                path: "/person" 
            }) 
          }

      },
      moreClick(event) {

         if (this.bizType == 1) {
            if (this.docData.docType != "test") {
            this.opMenuData = this.opMenuData.filter(item=>item.id != 'insertTest' && item.id != 'importTest' );
            }
            if (this.docData.docType != "question") {
              this.opMenuData = this.opMenuData.filter(item=>item.id != 'insertQuestion'  );
            }
         } else {
            this.opMenuData = this.opMenuData.filter(item=>item.id == 'insertTest');
         }
      
        this.$refs.opMenu.show(event);//
      },
      renameClick() {
        this.$showInputBox({
          caption:"提示",
          inputValue: this.docData.name,
          callback:(data) => {
              updateDoc(this.docId, data).then((res) => {
                  if (res.data.success == true) {
                      getDoc(this.docId).then((res) => {
                          if (res.data.success == true) {
                              this.docData.name = res.data.result.name;
                              this.$closeInputBox();
                          } 
                      })
                  }
              });
          }
        })
      },
      replyConfrim() {
        getReplyList(this.activeId).then((res) => {
            console.log(res.data);
            if (res.data.success == true) {
              this.fileReplyList = res.data.result;   
              this.showDocReplyModal = false;            
            } else {
                return;           
            }
        }) 
      },
      verClick(id) {
        let find = this.docData.files.filter(item=>item.id==id);
        if (find.length > 0) {
          this.verItemClick(find[0])
        }
      },
      opMenuClick(id) {
        if (id == "send") {
          this.sendUpdateData.name = this.docData.name; 
          this.sendUpdateData.docId = this.docData.id;
          this.sendUpdateData.files = this.docData.files;
          this.showSendUpdateModal = true

        } else if (id == "compare") {
          this.compare();
        } else if (id == "show") {
          getFile(this.activeId).then((res) => {
            this.$closeLoading();
            if (res.data.success == true) {   
                this.showTitle = res.data.result.userName + "的版本";
                this.showDocShowModal = true; 
                if (res.data.result.sendMsg == 1) {
                    this.$showToast({msg: '文档已更新，最新内容已添加至文档最前' }) 
                }
                
            } else {
                return;           
            }
          })
                    
        }  else if (id == "reply") {
          getReplyFile(this.activeId).then((res) => {
            this.$closeLoading();
            console.log(res);
            if (res.data.success == true) {  
                this.replyTitle = "回复" + this.docData.fileUserName;
                this.replyData =  res.data.result;
                this.showDocReplyModal = true;  

            } else {
                return;           
            }
          })
               
        }  
        else if (id == "update") {
          this.showUpFile = true;           
        } else if (id == "move") {
          getUserDir().then((res) => {
            console.log(res.data);
            if (res.data.success == true) {
              let data = res.data.result.records;
              let children = generateTree(data, "0", 2);
              this.dirData = [{"id":0, "name":"个人空间", "level": 1, "children": children}];
              console.log(this.dirData);
              this.showMove = true;
            }
          }) 
        } else if (id == 'delete') {
          this.$showMsgBox({
            caption:"询问",
            msg: '确定要删除吗？',
            callback:(data) => {
                if (data == "yes") {
                    delDoc(this.docId).then((res) => {
                        if (res.data.success == true) {
                            this.$router.push({
                              path: '/person'
                            })
                            return;
                        } else {
                            this.$showToast({msg: res.data.message});
                            return;                       
                        }
                    })
                } 
            }
          })
        } else if (id == "insertTest") {
          let newId = getUUID()
          let nowDate = getNowDate();
          let fileId = this.activeId;
          this.editFileData = {id: fileId, content : this.docContent}
          this.$refs.insertTestModal.newForm({id: newId, date: nowDate, fileId: fileId, status:"未完成", finish:"完成"});
        } else if (id == "insertQuestion") {
          console.log("11==")
          let newId = getUUID()
          let nowDate = getNowDate();
          let fileId = this.activeId;
          this.editFileData = {id: fileId, content : this.docContent}
          this.$refs.insertQuestionModal.newForm({id: newId, date: nowDate, fileId: fileId});
        } else if (id == "importTest") {
          this.$refs.testFileAdd.click();  
        }
      },  
      getMsg(){
        if (!isEmpty(this.token)) {
            noReadMsgCount().then((res) => {
              console.log("noReadMsgCount=====", res)
              this.msgCount = res.data.result;
            }) 
        }
      } ,
      msgChange() {
        this.getMsg();
      },
      initData() {
        this.shareId = this.$route.query.shareId;
        if (this.shareId != null) {
          this.getFileInfo(this.shareId);
        } else {
          this.docId = this.$route.query.id;
          this.getDocInfo(this.docId);
        }
      },
      getDocInfo(docId) {
        this.$showLoading();
        getDoc(docId).then((res) => {
            this.$closeLoading();  
            this.docData = res.data.result;
            console.log("getDoc====", this.docData );

            this.docData.createTime = getJsDateTime(this.docData.createTime);
            this.docData.likeCount = strToInt(this.docData.likeCount);
            this.docData.viewCount = strToInt(this.docData.viewCount);
            this.docData.commentCount = strToInt(this.docData.commentCount);
            this.docData.collectCount = strToInt(this.docData.collectCount);

            this.commentData = this.getCommentData(this.docData.comments);
            this.docData.files.forEach(item => {
              item.createTime = getJsDateTime(item.createTime)              
            });
            console.log("commentData", this.commentData );
            this.getActiveId();    
            this.totalData();
            this.bindEvent();   
 
            console.log(res.data.result);
        }) 
      },
      totalData() {
        this.filter.filterType = this.docData.docType;
        this.filter.fileId = this.activeId;
        getDocTotalInfo(this.filter).then((res) => {
           console.log("totaldata====", res);
           this.totalDataInfo = res.data.result;
        })  

      },
      getFileInfo(shareId) {
        this.$showLoading();
        getFileByShareId(shareId).then((res) => {
          this.$closeLoading();  
            this.docData = res.data.result;
            this.docData.createTime = getJsDateTime(this.docData.createTime);
            this.docData.likeCount = strToInt(this.docData.likeCount);
            this.docData.viewCount = strToInt(this.docData.viewCount);
            this.docData.commentCount = strToInt(this.docData.commentCount);
            this.docData.collectCount = strToInt(this.docData.collectCount);
            this.docId =  this.docData.id;

            this.commentData = this.getCommentData(this.docData.comments);
            this.docData.files.forEach(item => {
              item.createTime = getJsDateTime(item.createTime)              
            });
            console.log("commentData", this.commentData );
            console.log("docData", this.docData );
            this.getActiveId();
            this.$forceUpdate();
            this.bindEvent();

            console.log(res.data.result);
        }) 
      },
      
      getActiveId() {  
          this.activeId = this.docData.fileId       
          this.docData.files.forEach(item => {
            if (item.userId == sessionStorage.getItem("userId")) {
              this.activeId = item.id;
              this.docData.fileUserName = item.userName;
              this.docData.content = item.content;
            }             
          });   
          if (this.docData.fileType == 1) {
              this.docContent = this.docData.content;
          } else {
          } 
          
      },
      getFiles(docId){
        getFileList(docId).then((res) => {
            this.docData.files = res.data.result;
        }) 
      },
      addFile(file) {
        console.log(file);
        if (file == null) return;
        this.$showLoading();
        uploadFileA(file).then((res) => {
          console.log(res.data);
          if (res.data.success == true) {
            updateFile(this.docId, res.data.result.file).then((res) => {
              if (res.data.success == true) {
                getDoc(this.docId).then((res) => {
                  if (res.data.success == true) {
                    this.docData.files = res.data.result.files;
                    this.docData.files.forEach(item => {
                        item.createTime = getJsDateTime(item.createTime)              
                    });   
                    if (res.data.result.fileType == 1) {
                      this.docContent = res.data.result.content;
                    } else {
                    }                        
                  }
                })
                this.showUpFile = false;
                this.$closeLoading();
              }
            });
          }
        })          
      },
      verChange(item) {
        this.docData.filePath = item.fileUrl;
        this.docData.fileDate = item.createTime;
        this.showVersion = false;
      },
      
      getCommentData(data) {
        if (data==null) return null;
        let newData = data.filter(item=>item.parentId=="0");
        newData.forEach(item => {
          let child = data.filter(d=>d.parentId == item.id);
          child.forEach(d => {
            d.likeCount = strToInt(d.likeCount);
            d.commentCount = strToInt(d.commentCount); 
          }); 
          item.child = child;   
          item.createTime = getJsDateTime(item.createTime);   
          item.likeCount = strToInt(item.likeCount);
          item.commentCount = strToInt(item.commentCount);    
        });
        return newData;
      },
      dirChange(dirId) {
        changeDir(this.docId, dirId).then((res) => {
            console.log(res.data);
            if (res.data.success == true) {   
                this.$showToast({msg: '操作成功！' });       
                this.showMove = false;       
            } else {
                return;           
            }
        })

      },
      commentChange() {
          getDoc(this.docId).then((res) => {
              console.log(res.data);
              if (res.data.success == true) {   
                  this.docData.commentCount = res.data.result.commentCount;    
                  this.commentData = this.getCommentData(res.data.result.comments);                
              } else {
                  return;           
              }
          })
      },
      hasMyFile() {
        let result = false;
        let userId = sessionStorage.getItem("userId");
        if (!isEmpty(userId)) {
          let find = this.docData.files.filter(d=>d.userId == userId);
          result = find.length > 0;
        }   
        return result;      
      },
      edit: debounce(
          function() {            
              console.log("userinfo=============", sessionStorage.getItem("userId"));
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "" || userId == "null") {
                  if (config.configData.loginType == "wx") {
                    this.showScanLogin = true;
                  } else {
                    this.$router.push({
                        path: '/login',
                    }) 
                  }                    
              } else {  
                //不是本人创建                
                if (sessionStorage.getItem("userId") != this.docData.userId) {
                    //有没有自己的版本
                    if (this.docData.docType == "default") {
                        if (this.hasMyFile() == false) {
                          this.showCopyModal = true;
                        } else {
                          this.editFile("all");
                        }  
                    } else {
                      this.$showToast({msg: "非本人创建，不能编辑"});
                      return false
                    }
                           
                } else {
                  this.editFile("all");
                }
              }
                            
          }, 1000, true
      ),

      editFile(type) {
        this.getActiveId();
      
        if (this.hasMyFile() == true) {
          //如果有我的版本，获取我的文件 
          this.$showLoading();
          getMyFile(this.docData.id).then((res) => {
              this.$closeLoading();
              console.log("getMyFile==============",res.data);
              if (res.data.success == true) {   
                  this.docEditData = res.data.result;
                  this.docEditData.name = this.docData.name;
                  if (this.docData.docType == "default") {
                      if (type === "me") {
                        this.docEditData.content = keepContent(res.data.result.content, this.userName);
                      }
                      if (res.data.result.sendMsg == 1) {
                        this.$showToast({msg: '文档已更新，最新内容已添加至文档最前' }) 
                      }
                      this.showDocEditModal = true;
                  } else {
                      this.$refs.docEditPlusModal.open(this.docEditData);
                  }
              } else {
                  return;           
              }
          })
        } else {
          //普通文档如果没有我的版本，直接复制作者的版本
          this.$showLoading();
          getCopyFile(this.docData.fileId).then((res) => {
              this.$closeLoading();
              console.log("getCopyFile==============",res.data);
              if (res.data.success == true) {   
                  this.docEditData = res.data.result;
                  this.docEditData.name = this.docData.name;
                  if (type == "me") {
                    this.docEditData.content = keepContent(res.data.result.content, this.userName);
                  }
                  this.showDocEditModal = true;
              } else {
                  return;           
              }
          })

        }
      },
      down: debounce(
          function() {

               getPdfFile(this.docData.fileId).then((res) => {
                    console.log(res.data);
                    if (res.data.success == true) {   
                        window.open(res.data.message ,"_self");
                        this.docData.likeCount = res.data.result;
                    } else {
                        return;           
                    }
                })

              //console.log(this.docData.filePath);
              //window.open(this.docData.filePath ,"_self");
          }, 1000, true
      ),
      like: debounce(
          function() {

              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "") {
                this.showScanLogin = true;
              } else {
                likeDoc(this.docData.id).then((res) => {
                    console.log(res.data);
                    if (res.data.success == true) {   
                        this.docData.likeCount = res.data.result;
                    } else {
                        return;           
                    }
                })
              }

          }, 1000, true
      ),
      collect: debounce(
          function() {
              let userId = sessionStorage.getItem("userId");
              if (userId == null || userId == "") {
                this.showScanLogin = true;
              } else {
                collectDoc(this.docData.fileId).then((res) => {
                  console.log(res.data);
                  if (res.data.success == true) {   
                      this.docData.collectCount = res.data.result;
                  } else {
                      return;           
                  }
                })
              }
          }, 1000, true
      ),
      version(event) {
        this.stopPropa(event);
        document.addEventListener("click", this.closeDialog, false);// 监听关闭事件
        let show = this.showVersion;
        this.closeAll();
        this.showVersion = !show ;
      },
      closeDialog() {
        document.removeEventListener("click", this.closeDialog, false);
        this.closeAll();
      },
      stopPropa(event) {
        event || (event = window.event);
        event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
      },
      closeAll() {
        this.showVersion = false;
        this.showUser = false;
        this.showMsg = false;
        this.showNote = false;

      },

      userInfoClick(event) {
        this.stopPropa(event);
        document.addEventListener("click", this.closeDialog, false);// 监听关闭事件
        let show = this.showUser;
        this.closeAll();
        this.showUser = !show ;
      },
      msgInfoClick(event) {

        let userId = sessionStorage.getItem("userId");
        if (userId == null || userId == "") {
          this.showScanLogin = true;
        } else {
          this.getMsg();
          this.stopPropa(event);
          document.addEventListener("click", this.closeDialog, false);// 监听关闭事件
          let show = this.showMsg;
          this.closeAll();
          this.showMsg = !show ;
        }

      },
      editDocConfirm(data) {
        this.$showLoading();
        data.sendMsg = 1;//修改发消息
        updateUserFile(data).then((res) => {
          console.log("res===", res)
          this.$closeLoading(); 
            if (res.data.success == true) {
              if (objToStr(res.data.result.message) != "") {
                this.$showToast({msg: res.data.result.message}) 
              }
              this.initData();
              this.showDocEditModal = false;
            }  else {
              this.$showToast({msg: res.data.message});
            }           
        }) 
      },
      editDocConfirmPlus(data) {

      },
      // saveDocData(data) {

      //   console.log("暂存====")
      //   data.sendMsg = 0;//修改不发消息
      //   this.$showLoading();
      //   updateUserFile(data).then((res) => {
      //       this.$closeLoading(); 
      //       if (res.data.success == true) {
      //       } else {
      //         this.$showToast({msg: res.data.message});
      //       }
      //   }) 
      // },
      saveDocClose() {
        //this.initData();
        this.showDocEditModal = false;
      },
      compareDocClose() {
        this.showDocCompareModal = false;

      },
      share1() {
        this.docData.fileId = this.activeId;
        this.share(this.docData);
      },
      compare() {
        this.showDocCompareModal = true;

      },
      replys() {
        getReplyList(this.activeId).then((res) => {
            console.log(res.data);
            if (res.data.success == true) {
              this.fileReplyList = res.data.result;   
              this.showFileReplyListModal = true;            
            } else {
                return;           
            }
        })  
      
      },
      verItemClick(item) {
        this.activeId = item.id;
        this.docData.fileId = item.id;
        this.docData.content = item.content;
        this.docData.fileUserName = item.userName;
        this.docContent = item.content;
        //todo
        this.$showLoading();
        getFile(item.id).then((res) => {
            this.$closeLoading();
            if (res.data.success == true) {   
                this.docContent = res.data.result.content;
                if (res.data.result.sendMsg == 1) {
                    this.$showToast({msg: '文档已更新，最新内容已添加至文档最前' }) 
                }
            } else {
                return;           
            }
        })
        getReplyList(this.activeId).then((res) => {
            console.log(res.data);
            if (res.data.success == true) {
              this.fileReplyList = res.data.result;               
            } else {
                return;           
            }
        })  



      },
      getLoginInfo() {
        if (isEmpty(sessionStorage.getItem("token"))) {
          sessionStorage.setItem("token", localStorage.getItem("token")) ;
          sessionStorage.setItem("userId", localStorage.getItem("userId")) ;
          sessionStorage.setItem("realname", localStorage.getItem("realname"));
          sessionStorage.setItem("sex", localStorage.getItem("sex"));
          sessionStorage.setItem("memberLevelName", localStorage.getItem("memberLevelName"));
          sessionStorage.setItem("maxFileCount", localStorage.getItem("maxFileCount"));
        }

        this.token = sessionStorage.getItem("token");
        this.userId = sessionStorage.getItem("userId");
        this.userName =  sessionStorage.getItem("realname");

        if (isEmpty(sessionStorage.getItem("token"))) {
          this.userName = "未登录"
        }
        else if (isEmpty(sessionStorage.getItem("realname"))) {
          this.userName = "无名氏"
        }

      },

      loginConfirm() {
         this.token = sessionStorage.getItem("token");
         if (objToStr(this.token) != "") {
            this.userId = sessionStorage.getItem("userId");
            this.userName = this.getUserName();
            this.getFiles(this.docData.id);
            this.getActiveId();
            this.getMsg();
            if (this.docData.fileType == 1) {
                this.docContent = this.docData.content;
            } else {
            } 
         } 
         this.showScanLogin = false
      },
      copyConfrim(data) {
        console.log("data=====",data);
        this.editFile(data);
        this.showCopyModal = false;

      },
      noteClick() {
        this.stopPropa(event);
        //document.addEventListener("click", this.closeDialog, false);// 监听关闭事件
        this.showNote = !this.showNote;
        this.showUser  = false;// 隐藏弹窗
        this.showMsg  = false;// 隐藏弹窗

      },
      print() {
        console.log("print===================")
        //this.docContent = this.docData.content;
        //this.getActiveId();
      }
      
  }
}
</script>

<style scoped>

  .doc-title {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    top:0px;
    width: 100%;
    position: fixed;
    height: 60px;
    text-align: left;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, .1);
  }
  .doc-body {
    position: fixed;
    top:61px;
    left:0;
    right: 0;
    bottom: 0;
    width: 100%;
  }
  .doc-view {
    position: absolute;
    left : 5px;
    right: 325px;
    top: 5px;
    bottom: 80px;
    background-color: #f5f5f5;
  }
  .right {
    position: absolute;
    border-left: 1px solid rgba(0, 0, 0, .1) ;
    top:0px;
    right: 0;
    bottom: 0;
    width: 320px;
  }


  .bottom {
      position: fixed;
      left:0;
      right:320px;
      bottom: 20px;
  }

  .tool-bar {
      border-radius: 10px;
      height: 45px;
      padding-left:40px ;
      padding-right:40px ;
      background-color: #ffffff;
      border:1px solid rgba(0, 0, 0, .1);
  }

  .ver-item {
    padding-left: 15px;
    padding-right: 15px;
    padding-top:5px;
    padding-bottom:5px;
    white-space: nowrap;
  }

  .ver-item-active{
      color: #0070f9;
      border-bottom: 2px solid #0070f9;
      width: auto;
  }
  .note-ico {
    margin-top: 2px;
    width: 22px;
    height: 22px;
  }

  .rtfDiv >>> img {
      max-width: 100% ;
  }


  .rtfDiv {
      width: 900px;
      min-height: 700px;
      background-color: #fff;
      padding: 60px;
      margin : 15px 150px;
  }

  .doc-body .more {
    position: absolute;
    left:0;
    top:0;
    right: 0;
    height: 45px;
    background-color: #fff;
    box-shadow: 0px 1px 15px 1px rgba(0,0,0,0.25);
  }


</style>



// WEBPACK FOOTER //
// src/views/DocDetail.vue